export default {
    'welcome_to_login_syncd': '欢迎登录 Syncd',
    'username_or_email': '用户名或邮箱',
    'password': '密码',
    'login': '登录',
    'please_input_loginname': '请输入登录名(用户名或邮箱)',
    'please_input_password': '请输入密码',
    'strlen_between': '长度在 {min} 到 {max} 个字符',
    'help': '帮助',
    'contribute_to_syncd': '为 Syncd 做贡献',
    'personal_setting': '个人设置',
    'change_password': '修改密码',
    'sign_out': '退出登录',
    'dashboard': '控制台',
    'deploy': '发布',
    'submit_deploy_apply': '提交发布申请',
    'deploy_manage': '发布单管理',
    'deploying_deploy': '部署发布单',
    'project': '项目',
    'space_manage': '空间管理',
    'project_manage': '项目管理',
    'member_manage': '成员管理',
    'user': '用户',
    'role_manage': '角色管理',
    'user_manage': '用户管理',
    'server': '服务器',
    'cluster_manage': '集群管理',
    'server_manage': '服务器管理',
    'add_cluster': '新增集群',
    'please_input_keyword': '关键词搜索',
    'please_input_keyword_id_or_name': '关键词搜索，支持ID、名称',
    'network_error': '网络错误',
    'unknown_error': '未知错误',
    'operate_success': '操作成功',
    'operate': '操作',
    'name': '名称',
    'edit': '编辑',
    'delete': '删除',
    'server_group_name': '集群名称',
    'name_cannot_empty': '名称不能为空',
    'cancel': '取消',
    'enter': '确定',
    'edit_cluster': '编辑集群',
    'add_server': '新增服务器',
    'edit_server': '编辑服务器',
    'deleted': '已删除',
    'belong_cluster': '所属集群',
    'belong_cluster_cannot_empty': '所属集群不能为空',
    'keyword_search': '关键字搜索',
    'server_name': '服务器名称',
    'please_input_server_name': '请输入服务器名称',
    'IP_HOST_cannot_empty': 'IP/HOST不能为空',
    'please_input_server_IP_HOST': '请输入服务器IP/HOST',
    'SSH_port': 'SSH端口',
    'SSH_port_cannot_empty': 'SSH端口不能为空',
    'add_server': '新增服务器',
    'edit_server_info': '编辑服务器信息',
    'server_info': '服务信息',
    'add_role': '新增角色',
    'edit_role_info': '编辑角色信息',
    'role_name': '角色名称',
    'privilege_setting': '权限设置',
    'check_all': '全选',
    'add_user': '新增用户',
    'cluster': '集群',
    'role': '角色',
    'email': '邮箱',
    'status': '状态',
    'last_login': '上次登录',
    'username': '用户名',
    'role_cannot_empty': '角色不能为空',
    'username_cannot_empty': '用户名不能为空',
    'please_input_username': '请输入用户名',
    'password_cannot_empty': '密码不能为空',
    'please_input_password_length_limit': '请输入密码, 6到20个字符',
    'truename': '真实姓名',
    'mobile': '手机号',
    'allow_login': '允许登录',
    'email_cannot_empty': '邮箱不能为空',
    'please_input_email': '请输入邮箱',
    'normal': '正常',
    'locking': '锁定',
    'last_login_time': '上次登录时间',
    'last_login_ip': '上次登录IP',
    'email_format_wrong': '邮箱格式错误',
    'users_cannot_login_after_being_banned': '禁止后用户将无法登录',
    'data_repeat_reenter_please': '数据重复，请重新输入',
    'in_verification_please_wait': '验证中，请稍后',
    'username_exists_please_reenter': '用户名已经存在，请重新输入',
    'verifying_username_is_being_used_please_wait': '正在验证用户名是否被占用，请稍等',
    'email_is_exists_please_reenter': '邮箱已经存在，请重新输入',
    'verifying_email_is_being_used_please_wait': '正在验证邮箱是否被占用，请稍等',
    'network_error_verify_failed': '网络错误, 校验失败',
    'project_space': '项目空间',
    'add_project_space': '新增项目空间',
    'input_name_to_search': '按名称搜索',
    'edit_project_space_info': '编辑项目空间信息',
    'project_space_name': '项目空间名称',
    'description': '描述信息',
    'add_member_to_space': '添加成员到项目空间',
    'add': '添加',
    'project_member_select_space_tips': '成员管理需要指定项目空间，请点击 \'选择项目空间\' 按钮，在弹出窗口中进行选择。',
    'prompt_message': '提示信息',
    'select_project_space': '选择项目空间',
    'switch_project_space': '切换项目空间',
    'add_new_member': '添加新成员',
    'looking_for_users': '正在查找用户...',
    'user_not_found': '未查找到用户',
    'search_for_users_by_username_and_email': '通过用户名、邮箱搜索用户',
    'search_and_select_users_before_adding': '请先搜索并选择用户后再添加',
    'member_added_successfully': '成员添加成功',
    'member_already_exists_do_not_add_repeat': '成员已经存在，请勿重复添加',
    'remove': '移除',
    'project_select_space_tips': '项目管理需要指定项目空间，请点击 \'选择项目空间\' 按钮，在弹出窗口中进行选择。',
    'add_project': '新增项目',
    'project_name': '项目名称',
    'please_input_project_name': '请输入项目名称',
    'please_input_project_description': '请输入项目描述信息',
    'open_audit': '开启审核',
    'if_open_apply_need_audit': '开启后，上线单需要审核通过后才能发起上线',
    'repo_url': '仓库地址',
    'please_input_repo_url': '请输入仓库地址',
    'repo_url_cannot_empty': '仓库地址不能为空',
    'repo_branch': '指定上线分支',
    'online_cluster': '线上集群',
    'online_cluster_cannot_empty': '线上集群不能为空',
    'user': '用户',
    'user_cannot_empty': '用户不能为空',
    'deploy_user': '目标机用户',
    'path': '目录',
    'deploy_path': '代码/包部署的目录',
    'deploy_path_cannot_empty': '请设置代码部署目录',
    'pre_deploy_cmd': '部署前运行命令',
    'pre_deploy_cmd_tips': '代码部署之前在目标机运行的命令，每行一个命令',
    'after_deploy_cmd': '部署后运行命令',
    'after_deploy_cmd_tips': '代码部署之后在目标机运行的命令，每行一个命令',
    'deploy_timeout': '部署超时时间(秒)',
    'deploy_timeout_tips': '部署命令最大运行时间',
    'project_enable': '项目启用',
    'edit_project': '编辑项目',
    'view': '查看',
    'retry': '重试',
    'project_id': '项目ID',
    'build': '构建',
    'build_setting': '构建设置',
    'build_script': '构建脚本',
    'view_build_script_eg': '查看构建脚本示例',
    'open': '开启',
    'close': '关闭',
    'repo_setting': '仓库设置',
    'if_not_need_to_assign_branch_name': '若不指定，需要在发起上线时手动填写分支名称',
    'deploy_setting': '部署设置',
    'selected_cluster_list': '已选集群列表',
    'cluster_list': '集群列表',
    'view_cluster_server': '服务列表',
    'view_project_info': '查看项目信息',
    'base_setting': '基本设置',
    'need_audit': '需要审核',
    'not_audit': '不需审核',
    'audit': '审核',
    'unaudit': '待审核',
    'edit_build_script': '编辑构建脚本',
    'illustrate': '说明',
    'build_script_tips': '脚本会在代码下载完成后执行，构建脚本支持的变量',
    'build_script_env_workspace': '代码仓库本地副本目录',
    'build_script_env_pack_file': '打包文件绝对地址，构建完成后将需要部署到线上的代码打包到此文件中，必须使用 <span class="code">tar -zcf</span> 命令进行打包。部署模块会将此压缩包分发到目标主机并解压缩到指定目录，请按照要求打包，否则会部署失败。',
    'select_project': '选择项目',
    'project_space_cannot_empty': '项目空间不能为空',
    'project_cannot_empty': '项目不能为空',
    'input_apply_order': '填写上线单',
    'input_deploy_apply': '填写上线申请',
    'deploy_mode': '上线模式',
    'deploy_mode_cannot_empty': '上线模式不能为空',
    'branch_deploy': '分支上线',
    'tag_deploy': 'Tag上线',
    'deploy_mode_tips': '测试环境推荐分支上线，生产环境推荐tag上线',
    'apply_name': '发布单名称',
    'apply_order': '发布单',
    'please_input_apply_name': '请输入上线单名称',
    'tag_name': 'Tag名称',
    'tag_name_cannot_empty': 'Tag名称不能为空',
    'please_input_tag_name': '请输入Tag名称',
    'branch_name_cannot_empty': '分支名称不能为空',
    'please_input_branch_name': '请输入分支名称',
    'branch_name': '分支名称',
    'deploy_illustrate': '上线说明',
    'please_input_deploy_illustrate': '请详细填写上线说明',
    'deploy_illustrate_cannot_empty': '上线说明不能为空',
    'commit_version': '选择上线版本',
    'version': '版本',
    'please_input_commit_version': '输入上线版本hash',
    'branch': '分支',
    'deploy_apply_submit_success': '恭喜，上线申请提交成功',
    'submit_success': '提交成功',
    'submit_time': '提交时间',
    'deploy_status': '上线状态',
    'audit_status': '审核状态',
    'select_project': '选择项目',
    'rollback_apply': '绑定回滚单',
    'belong_to_space': '所属空间',
    'submiter': '提交者',
    'pass': '通过',
    'denied': '拒绝',
    'wait_online': '待上线',
    'onlineing': '上线中',
    'success': '成功',
    'failed': '失败',
    'drop': '废弃',
    'rollback': '回滚',
    'online': '上线',
    'space_name': '空间名称',
    'audit_pass': '审核通过',
    'audit_denied': '审核拒绝',
    'deined_reason': '拒绝原因',
    'edit_apply_order': '编辑上线单',
    'today': '今天',
    '7day': '7天内',
    'within_one_month': '1个月内',
    'within_three_months': '3个月内',
    'within_a_year':'一年内',
    'any_time': '时间不限',
    'not_online': '未上线',
    'online_success': '上线成功',
    'online_failed': '上线失败',
    'deprecated': '已废弃',
    'update_success': '更新成功',
    'audit_success': '审核成功',
    'drop_deploy_apply_tips': '此操作将废弃该上线单, 是否继续?',
    'have_onlined': '已上线',
    'belong_project': '所属项目',
    'forced_termination': '强制终止',
    'last_buid_time': '上次构建时间',
    'cost_time': '耗时',
    'stopping': '正在终止',
    'building': '构建中',
    'build_finish': '构建成功',
    'build_failed': '构建失败',
    'build_ing': '构建中',
    'unbuild': '未构建',
    'uncreate': '未生成',
    'build_log': '构建日志',
    'tar_pack_path': 'Tar包位置',
    'deploy': '部署',
    'redeploy': '重新部署',
    'rollback_apply_order_tips': '回滚操作将以新发布单的形式对历史代码包进行重新部署',
    'rollback_created': '回滚单已生成',
    'rollback_unstart': '回滚未开始',
    'rollbacking': '回滚中',
    'rollback_success': '回滚成功',
    'rollback_failed': '回滚失败',
    'rollback_drop': '回滚单废弃',
    'rollback_unknow': '回滚状态未知',
    'click_to_view_rollback_order': '点击进入回滚单',
    'wait_deploy': '等待部署',
    'deploying': '部署中',
    'deploy_success': '部署成功',
    'deploy_failed': '部署失败',
    'be_deined': '被终止',
    'deploy_log': '部署日志',
    'makesure_rollback_order': '确定要进行回滚操作吗？',
    'build_success_and_deploy': '请构建成功后再进行部署操作',
    'deploy_tips': '部署提示',
    'start_build': '开始构建',
    'i_known': '知道了',
    'yes': '是',
    'no': '否',
    'have_enabled': '已启用',
    'not_enable': '未启用',
    'avatar': '头像',
    'current_password': '当前密码',
    'new_password': '新密码',
    'current_password_cannot_empty': '当前密码不能为空',
    'new_password_cannot_empty': '新密码不能为空',
    'apply_type': '类型',
    'rollback_creating': '回滚单生成中',
    'rollback_tips': '当前是自动生成的回滚单',
    'back_apply': '返回原发布单',
    'email_setting': '邮箱设置',
    'audit_notice': '审核通知',
    'audit_notice_tips': '请输入接收审核通知的邮箱地址',
    'audit_notice_explain': '系统通过邮件通知相关负责人审核待审单，多个邮箱地址请用 <span class="app-tag-info">,</span> 相隔',
    'deploy_notice': '上线通知',
    'deploy_notice_tips': '请输入接收上线通知的邮箱地址',
    'deploy_notice_explain': '接收上线通知的邮箱地址，多个邮箱地址请用 <span class="app-tag-info">,</span> 相隔',
    'hook': 'Hook',
    'edit_hook_script': '编辑Hook命令',
    'build_hook_script': '构建完成后执行命令',
    'deploy_hook_script': '部署完成后执行命令',
    'build_hook_script_tips': '命令会在构建完成(成功或失败)后执行，支持的变量',
    'deploy_hook_script_tips': '命令会在部署完成(成功或失败)后执行，支持的变量',
    'command': '执行命令',
    'command_template': '命令模板',
    'add_command_template': '添加命令模板',
    'template_id': '模板ID',
    'command_template_name': '命令模板名称',
    'execute_user': '执行用户',
    'online_host': '主机ip',
    'online_host_tips': '主机ip,一行一个。',
    'command_tips': '定义在远程主机执行的命令',
    'command_template_enable': '命令模板启用',
    'command_template_select_space': '命令模板需要指定项目空间,请点击 \'选择项目空间\' 按钮，在弹出窗口中进行选择。',
    'command_cannot_empty': '命令不能为空。',
    'command_template_edit': '修改模板',
    'view_template_info': '查看模板',
    'template_cannot_empty': '模板不能为空',
    'command_operate': '执行命令单',
    'command_apply': '申请执行命令',
    'command_name': '命令单名称',
    'command_mode': '执行模式',
    'tpl_mode': '按模板执行',
    'flow_mode': '按模板流执行',
    'please_input_name': '请输入名称',
    'command_illustrate': '执行说明',
    'command_illustrate_cannot_empty': '执行说明不能为空',
    'please_input_command_illustrate': '请输入执行说明',
    'id': 'ID',
    'command_operate_name':'名称',
    'command_status': '执行状态',
    'command_apply_submit_success': '恭喜，命令申请提交成功',
    'not_execute': '未执行',
    'executing': '执行中',
    'execute_success': '执行成功',
    'execute_failed':'执行失败',
    'select_template': '选择模板',
    'command_flow': '命令执行流',
    'belong_template': '所用模板',
    'execute': '执行',
    'reexecute': '重新执行',
    'execute_release': '命令发布单',
    'workflow': '任务流',
    'workflow_mgr': '任务流管理',
    'works': '任务',    
    'workflow_apply': '创建任务流',
    'ongoing': '进行中',
    'finished': '已完成',
    'openflow':  '打开工作流',
    'onekey_audit': '一键审核',
    'no_need_onekey_audit': '暂无可审核数据',
    'finish_workflow': '结束任务流',
    'makesure_finish_workflow': '确定结束任务流吗?',
    'makesure_finish_detail': '结束任务流,其包含所有未完成任务将被废弃。',
    
}
